export default "__VITE_ASSET__CFLH1oLD__"